import React from 'react';

import ProgrammeLayout from '../../../../layouts/programme/ProgrammeLayout';

import './home.scss';

const Home = () => (
  <ProgrammeLayout hideNav>
    <div className="home" data-testid="home">
      <p>Please select a programme</p>
    </div>
  </ProgrammeLayout>
);

export default Home;
